import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  NotFoundComponent,
  NotAuthorizedComponent,
} from '@dcs-workspace/back-office/common';
import {MobileDocumentScanningComponent} from "@dcs-workspace/shared";

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'not-found', component: NotFoundComponent },
  { path: 'not-authorized', component: NotAuthorizedComponent },
  { path: 'mobile-document-scanning', component: MobileDocumentScanningComponent },
  {
    path: 'home',
    loadChildren: () =>
      import('@dcs-workspace/back-office/home').then(
        (m) => m.BackOfficeHomeModule
      ),
  },
  {
    path: 'form-templates',
    loadChildren: () =>
      import('@dcs-workspace/back-office/form-templates').then(
        (m) => m.BackOfficeFormTemplatesModule
      ),
  },
  {
    path: 'forms',
    loadChildren: () =>
      import('@dcs-workspace/back-office/forms').then(
        (m) => m.BackOfficeFormsModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
